import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

export const LanguageSwitcher = ({ variant = "dark" }) => {
  const { lang, setLang } = useLanguage();
  const isLight = variant === "light";

  const baseColor = isLight ? "text-white/70" : "text-[#0D2F4C]/60";
  const activeColor = isLight ? "text-white" : "text-[#0D2F4C]";
  const borderColor = isLight ? "border-white/30" : "border-[#0D2F4C]/30";

  return (
    <div
      className={`flex items-center gap-2 text-xs tracking-[0.25em] uppercase border ${borderColor} px-3 py-1.5`}
      data-testid="language-switcher"
    >
      <button
        data-testid="lang-fr-btn"
        onClick={() => setLang("fr")}
        className={`transition-colors duration-200 ${
          lang === "fr" ? `${activeColor} font-semibold` : `${baseColor} hover:${activeColor}`
        }`}
      >
        FR
      </button>
      <span className={baseColor}>/</span>
      <button
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`transition-colors duration-200 ${
          lang === "en" ? `${activeColor} font-semibold` : `${baseColor} hover:${activeColor}`
        }`}
      >
        EN
      </button>
    </div>
  );
};
